import React, { useState, Fragment, useEffect } from 'react';
import {
  Row,
  Input,
  Label,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  InputGroupText,
  InputGroupAddon,
  InputGroup,
  FormGroup,
  Spinner,
  Tooltip,
  CustomInput
} from 'reactstrap';
import ReviewVoucher from './ReviewVoucher';
// import ShowVoucherView from './ShowVoucherView';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import PropTypes from 'prop-types';
import moment from 'moment';
import { AxiosAPI, getGroupID } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_Vouchers_By_Id, gAPI_Amadues_Rooms, API_Xola, gAPI_Mews_Rooms,
  gAPI_QuestionOptionList, gAPI_Internal_Property_By_Id
} from '../../../../../../../constants/APIs';
import CatgeoryData from '../../../../../../../data/voucherCategory.json';
import searchTagsData from '../../../../../../../data/vocuherSearchTags.json';
import CustomSelectInput from '../../../../../../../components/common/CustomSelectInput';
import Select from 'react-select';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageGallery from '../../../../propinfo/gallery/index';
import InviteVoucher from './InviteVoucher';
import PreviewVoucherList from './PreviewVoucherList';
import RoomSettings from './RoomSettings';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faCopy } from '@fortawesome/free-solid-svg-icons';
import StandaloneCurrency from '../../../../../../../data/StandaloneCurrency';
import IconGallery from '../../../../propinfo/iconGallery';
import { ChromePicker } from 'react-color';
import { setBackGroundColor } from '../../../../integration/style/DigitalAssistantStyle';
import { NotificationManager } from '../../../../../../../components/common/react-notifications';
const Weekdays = [
  { value: 'Monday', name: 'Monday' },
  { value: 'Tuesday', name: 'Tuesday' },
  { value: 'Wednesday', name: 'Wednesday' },
  { value: 'Thursday', name: 'Thursday' },
  { value: 'Friday', name: 'Friday' },
  { value: 'Saturday', name: 'Saturday' },
  { value: 'Sunday', name: 'Sunday' },
];
const quillModules = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link', 'image'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];


const dayValidity = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
const monthValidity = [{ val: 1, label: 'Jan' }, { val: 2, label: 'Feb' }, { val: 3, label: 'Mar' }, { val: 4, label: 'Apr' }, { val: 5, label: 'May' }, { val: 6, label: 'Jun' },
{ val: 7, label: 'Jul' }, { val: 8, label: 'Aug' }, { val: 9, label: 'Sep' }, { val: 10, label: 'Oct' }, { val: 11, label: 'Nov' }, { val: 12, label: 'Dec' }];
const yearValidity = ['2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032', '2033', '2034', '2035'];
function VouchersForm({
  visible,
  toggle,
  formLabel,
  submit, reportingTagData,
  updateVoucherData, xolaIntegration,
  id, isHostedPageIntegration,
  propertyId, groupId, thirdPartyVoucher,
  handleReject, email, amadeus,
  locale, ShowInviteVoucher,
  handleUpdate, invitationId,
  processingFee, approvalStatus,
  mews, memberShipTags
}) {
  const [roomlst, setRooms] = useState([]);
  const [isActive, setisActive] = useState(false);
  const [propertyData, setPropertyData] = useState({
    bmbVoucherProcessingFee: 0
  });
  const [voucherFeeData, setVoucherFeeData] = useState(false
  );
  const [addedMonths, setAddedMonths] = useState([]);
  const [showExpiryDiv, setExpiryModel] = useState(false);
  // const [acceptModal, setAcceptModal] = useState(false);
  // const [rejectModal, setRejectModal] = useState(false);
  const [ToolTip, setToolTip] = useState(false);
  const [mewsRoomList, setMewsRoomList] = useState([]);
  const [selectedTags, setselectedTags] = useState([]);
  const [tags, setTags] = useState([]);
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [iconGalleryVisible, setIconGalleryVisible] = useState(false);
  const [imageIndex, setImageIndex] = useState(-1);
  const [iconIndex, setIconIndex] = useState(-1);
  const [error, seterror] = useState(false);
  const [addTagModel, setAddTagModel] = useState(false);
  const [ownTag, setOwnTag] = useState('');
  const [loading, setLoading] = useState(false);
  const [showReviewVoucher, setShowReviewVoucher] = useState(false);
  const [showReviewVoucherList, setShowReviewVoucherList] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [showselect, setshowselect] = useState(true);
  const [couponList, setCouponList] = useState([]);
  const [reportingTags, setReportingTags] = useState([]);
  const [issearchTag, setSearchTag] = useState(false);
  const [selectedReportingTags, setSelectedReportingTags] = useState([]);
  const [membershipTags, setMembershipTags] = useState([]);
  const [isShowMembership, setIsShowMembership] = useState(false);
  const [selectedMemberShipTags, setSelectedMembershipTags] = useState([]);
  const [addMemberShipModal, setAddMemberShipModal] = useState(false);
  const [expiryMonth, setExpiryMonth] = useState(moment().add(2, 'months').format('YYYY-MM-DD'));
  let [voucherData, setVoucherData] = useState(
    updateVoucherData || {
      groupId: getGroupID(),
      propertyId: propertyId,
      name: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      introduction: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      details: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      conditions: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      url: '',
      status: 'Draft',
      isMemberShip: false,
      price: 0,
      couponId: "-1",
      discountedPrice: 0,
      discount: 0,
      websiteLink: '',
      totalPurchaseLimit: 100,
      expiryAfterPurchase: 12,
      ownExpiryDate: moment().add(30, 'days').format('YYYY-MM-DD'),
      startDayValidity: 1,
      startMonthValidity: 1,
      endDayValidity: 31,
      endMonthValidity: 12,
      startYearValidity: 0,
      endYearValidity: 0,
      processingFee: 0,
      orderPurchaseLimit: 5,
      startDate: moment().format('YYYY-MM-DD'),
      expiryDate: moment().add(30, 'days').format('YYYY-MM-DD'),
      creator: 'Admin',
      sellingOptions: [{
        roomSettings: {
          noOfChildren: 0,
          noOfAdults: 0,
          noOfNights: 0,
          promoCode: '',
          couponId: '-1',
          noOfRooms: 0,
          noOfAdultsOperator: "equals",
          noOfChildrenOperator: "equals",
          bookingStartDate: moment().format('YYYY-MM-DD'),
          bookingEndDate: moment().format('YYYY-MM-DD'),
          travelStartDate: '0001-01-01',
          travelEndDate: '0001-01-01',
          redeemOption: 2,
          days: 'Monday,Sunday,Saturday,Tuesday,Wednesday,Thursday,Friday'
        }
      },
      ],
      showExpiryDate: false,
      showValidityPeriod: false,
      currencies: [],
      displayOrder: 1,
      taxPercentage: '0',
      searchTags: [],
      reportingTags: [],
      images: [],
      icons: [],
      membershipTags: [],
      options: false,
      taxIncluded: 'true',
      taxAmount: '0',
      inventoryOptionLevel: false,
      giftEnabled: true,
      printVoucherTerms: false,
      location: '',
      category: 'Accommodation',
      provider: 'RMS',
      includedItems: '',
      bookLater: false,
      roomId: '-1',
      hidePrice: false,
      instruction: [
        {
          statement: '',
          languageCode: locale,
        },
      ],
      redeemOption: '2',
    }
  );
  const [tooltipOpen, setTooltipOpen] = useState(false);
  useEffect(() => {
    if (xolaIntegration !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${API_Xola}/${xolaIntegration.id}/couponList?group_id=${getGroupID()}`,
      }).then((res) => {
        console.log(res.data.data);
        setCouponList(res.data.data);
      });
    }
    if (amadeus !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Amadues_Rooms}/${amadeus.id}/gethotelrooms?group_id=${getGroupID()}`,
      }).then((res) => {
        setRooms(res.data.guestRooms);
      });
    }
    if (mews !== undefined) {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Mews_Rooms}/${mews.id}/gethotelrooms?group_id=${getGroupID()}`,
      }).then((res) => {
        setMewsRoomList(res.data);
      });
    }
    if (id !== undefined) {
      setLoading(true);
      setisActive(true);
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Vouchers_By_Id}/${id}`,
      }).then((res) => {
        if (moment(res.data.ownExpiryDate).format('YYYY') == "0001")
          res.data.ownExpiryDate = moment().add(30, 'days').format('YYYY-MM-DD');
        if (res.data.taxIncluded === true) {
          let val = parseFloat(res.data.price) -
            parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0);
          res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
            val)
          ).toFixed(2);
        } else {
          res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
            parseFloat(res.data.discountedPrice) -
            parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0))
          ).toFixed(2);
        }
        res.data.taxIncluded = res.data.taxIncluded.toString();
        res.data.sellingOptions = res.data.sellingOptions.filter(f => f.isPrimary === true);
        setVoucherData(res.data);
        if (res.data.propertyId === propertyId) {
          loadProperty(res.data.propertyId, groupId === undefined ? getGroupID() : groupId);
        } else {
          loadProperty(res.data.propertyId, groupId === undefined ? getGroupID() : groupId);
        }
        let reportingOptions = [];
        let selectedOptions = [];
        if (res.data.reportingTags !== undefined) {
          res.data.reportingTags.map((item) => {
            if (reportingOptions.filter(m => m.value === item).length === 0) {
              reportingOptions.push({
                label: item,
                value: item,
                key: item
              });
              selectedOptions.push({
                label: item,
                value: item,
                key: item
              });
            }
          });

        }
        let membershipOptions = [];

        if (memberShipTags !== undefined && memberShipTags.length > 0) {
          memberShipTags.map((item) => {
            if (membershipOptions.filter(s => s.label === item).length === 0) {
              membershipOptions.push({
                label: item,
                value: item,
                key: item
              });
            }
          })
        }
        let selectedMemberShip = [];
        if (res.data.membershipTags !== undefined) {
          res.data.membershipTags.map((item) => {
            if (membershipOptions.filter(m => m.value === item).length === 0) {
              membershipOptions.push({
                label: item,
                value: item,
                key: item
              });
            }
            if (selectedMemberShip.filter(m => m.value === item).length === 0) {
              selectedMemberShip.push({
                label: item,
                value: item,
                key: item
              });
            }
          });
        }
        selectedOptions = selectedOptions.filter((f) => f.value !== 'Add own tag');
        setSelectedReportingTags(selectedOptions);
        reportingOptions.push({
          label: 'Add own tag',
          value: 'Add own tag',
          key: 'Add own tag',
        });
        if (reportingTagData !== undefined && reportingTagData.length > 0) {
          reportingTagData.map((m) =>
            reportingOptions.push({
              label: m,
              value: m,
              key: m
            }))
        }
        setReportingTags(reportingOptions);

        selectedMemberShip = selectedMemberShip.filter((f) => f.value !== 'Add membership');
        setSelectedMembershipTags(selectedMemberShip);
        membershipOptions.push({
          label: 'Add membership',
          value: 'Add membership',
          key: 'Add membership',
        });
        // if (reportingTagData !== undefined && reportingTagData.length > 0) {
        //   reportingTagData.map((m) =>
        //     reportingOptions.push({
        //       label: m,
        //       value: m,
        //       key: m
        //     }))
        //   }     


        setMembershipTags(membershipOptions);



        AxiosAPI({
          method: 'get',
          url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Vouchers`,
        }).then((res1) => {
          var options = [];
          try {
            res1.data.map((item) =>
              options.push({
                label: item.option,
                value: item.option,
                key: item.id,
              })
            );
          } finally {
          }
          options.push({
            label: 'Add own tag',
            value: 'Add own tag',
            key: 'Add own tag',
          });
          searchTagsData.data.map((m) => {
            options.push({
              label: m.name,
              value: m.value,
              key: m.value
            });
          });
          try {
            res.data.searchTags.map((item) => {
              if (searchTagsData.data.filter(m => m.value === item).length === 0)
                options.push({
                  label: item,
                  value: item,
                  key: item
                });
            }
            );
          } finally {
          }
          setTags(options);
          var selectedTags = [];
          try {
            res.data.searchTags.map((item) =>
              selectedTags.push(options.filter((cat) => cat.value === item)[0])
            );
          } finally {
          }
          setselectedTags(selectedTags);
          setLoading(false);
        });
        //.catch((err) => console.log('err', err));
      });
      //.catch((err) => console.log('err', err));
    } else {
      let memberShipOptions = [];
      if (memberShipTags !== undefined && memberShipTags.length > 0) {
        memberShipTags.map((item) => {
          if (memberShipOptions.filter(s => s.label === item).length === 0) {
            memberShipOptions.push({
              label: item,
              value: item,
              key: item
            });
          }
        })
      }
      let reportingOptions = [];
      reportingOptions.push({
        label: 'Add own tag',
        value: 'Add own tag',
        key: 'Add own tag',
      });
      memberShipOptions.push({
        label: 'Add membership',
        value: 'Add membership',
        key: 'Add membership',
      });
      if (reportingTagData !== undefined && reportingTagData.length > 0) {
        reportingTagData.map((m) =>
          reportingOptions.push({
            label: m,
            value: m,
            key: m
          }))
      }
      setReportingTags(reportingOptions);

      var options = [];
      try {
        options.push({
          label: 'Add own tag',
          value: 'Add own tag',
          key: 'Add own tag',
        });
        // res.data.map((item) =>
        //   options.push({
        //     label: item.option,
        //     value: item.option,
        //     key: item.id,
        //   })
        // );    
        searchTagsData.data.map((m) => {
          options.push({
            label: m.name,
            value: m.value,
            key: m.value
          });
        });
        setTags(options);
      } finally {
      }
      loadProperty(propertyId, groupId === undefined ? getGroupID() : groupId);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_QuestionOptionList}?propertyId=${propertyId}&type=Vouchers`,
      }).then((res) => {
        if (res.data.length > 0) {
          var options = [];
          try {
            options.push({
              label: 'Add own tag',
              value: 'Add own tag',
              key: 'Add own tag',
            });
            res.data.map((item) =>
              options.push({
                label: item.option,
                value: item.option,
                key: item.id,
              })
            );
            searchTagsData.data.map((m) => {
              options.push({
                label: m.name,
                value: m.value,
                key: m.value
              });
            });
            setTags(options);
          } finally {
          }

        }


      });
      setMembershipTags(memberShipOptions);
      //.catch((err) => console.log('err', err));
    }
  }, [id]);

  const hanldeLoading = (val) => {
    setIsLoading(val);
  };
  const loadProperty = (propertyId, group_id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group_id}`,
    })
      .then((res) => {
        setPropertyData(res.data);
        if (id !== undefined)
          setShowReviewVoucher(true);
      })
  };
  const close_clicked = () => {
    setShowReviewVoucher(!showReviewVoucher);
  }
  const getLocalStatement = (statements) => {
    if (statements !== undefined && statements.length > 0) {
      const index = statements.findIndex((m) => m.languageCode === locale);
      if (index === -1) {
        const englishIndex = statements.findIndex(
          (m) => m.languageCode === 'en'
        );
        if (englishIndex !== -1) {
          return statements[englishIndex].statement;
        }
      } else {
        return statements[index].statement;
      }
    } else {
      return '';
    }
  };
  const handleChangeNameArr = (e) => {
    if (voucherData.name.length > 0) {
      const index = voucherData.name.findIndex(
        (m) => m.languageCode === locale
      );
      if (index === -1) {
        const newStatement = {
          statement: e.target.value,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          name: [...voucherData.name, newStatement],
        });
      } else {
        let newArr = [...voucherData.name];
        newArr[index].statement = e.target.value;
        setVoucherData({
          ...voucherData,
          name: newArr,
        });
      }
    } else {
      const newStatement = {
        statement: e.target.value,
        languageCode: locale,
      };
      setVoucherData({
        ...voucherData,
        name: [...voucherData.name, newStatement],
      });
    }
  };
  const togglegallery = (index) => {
    setImageIndex(index);
    setGalleryVisible(!galleryVisible);
  };

  const toggleIcongallery = (index) => {
    setIconIndex(index);
    setIconGalleryVisible(!iconGalleryVisible);
  };

  const selectedImage = (image) => {
    const newItems = [...voucherData.images];
    newItems[imageIndex].url = image.src;
    newItems[imageIndex].Width = parseInt(image.width);
    newItems[imageIndex].Height = parseInt(image.height);
    setVoucherData({
      ...voucherData,
      images: newItems,
    });
  };

  const selecedIcon = (image) => {
    if (image !== undefined) {
      const newItems = [...voucherData.icons];
      newItems[iconIndex].url = image.src;
      newItems[iconIndex].Width = parseInt(24);
      newItems[iconIndex].Height = parseInt(24);
      setVoucherData({
        ...voucherData,
        icons: newItems,
      });
    }
  };


  const handleOwntag = (val) => {
    if (issearchTag === true) {
      let tag = [...tags];
      tag.push({ label: val, value: val, key: val });
      let tag1 = [...selectedTags];
      tag1.push({ label: val, value: val, key: val });
      setTags(tag);
      setselectedTags(tag1);
      setAddTagModel(!addTagModel);
      setOwnTag('');
      const tagsArr = tag1.map((elem) => elem.value);      
      setVoucherData({
        ...voucherData,
        searchTags: tagsArr,
      });
    } else {
      let tag = reportingTags;
      tag.push({ label: val, value: val, key: val });
      let tag1 = selectedReportingTags;
      tag1.push({ label: val, value: val, key: val });
      setReportingTags(tag);
      setSelectedReportingTags(tag1);
      setAddTagModel(!addTagModel);
      setOwnTag('');
      const tagsArr = tag1.map((elem) => elem.value);
      setVoucherData({
        ...voucherData,
        reportingTags: tagsArr,
      });
    }
    setshowselect(true);
  }

  const AddMemberShipTags = (val) => {    
    let tag = membershipTags;
    tag.push({ label: val, value: val, key: val });
    let tag1 = selectedMemberShipTags;
    tag1.push({ label: val, value: val, key: val });
    setMembershipTags(tag);
    setSelectedMembershipTags(tag1);
    setAddMemberShipModal(!addMemberShipModal);
    setOwnTag('');
    const tagsArr = tag1.map((elem) => elem.value);
    setVoucherData({
      ...voucherData,
      membershipTags: tagsArr,
    });
    setshowselect(true);
  }

  const handleCheckChange = (e) => {
    setVoucherData({
      ...voucherData,
      [e.target.name]: e.target.checked,
    });
  };

  const handleChangeIntroductionArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.introduction.length > 0) {
        const index = voucherData.introduction.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            introduction: [...voucherData.introduction, newStatement],
          });
        } else {
          let newArr = [...voucherData.introduction];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            introduction: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          introduction: [...voucherData.introduction, newStatement],
        });
      }
    }
  };

  const handleChangeDetailsArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.details.length > 0) {
        const index = voucherData.details.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            details: [...voucherData.details, newStatement],
          });
        } else {
          let newArr = [...voucherData.details];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            details: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          details: [...voucherData.details, newStatement],
        });
      }
    }
  };

  const handleChangeConditionsArr = (source, e) => {
    if (source === 'user') {
      if (voucherData.conditions.length > 0) {
        const index = voucherData.conditions.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            conditions: [...voucherData.conditions, newStatement],
          });
        } else {
          let newArr = [...voucherData.conditions];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            conditions: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          conditions: [...voucherData.conditions, newStatement],
        });
      }
    }
  };

  const handleInstructions = (source, e) => {
    if (source === 'user') {
      if (voucherData.instruction.length > 0) {
        const index = voucherData.instruction.findIndex(
          (m) => m.languageCode === locale
        );
        if (index === -1) {
          const newStatement = {
            statement: e,
            languageCode: locale,
          };
          setVoucherData({
            ...voucherData,
            instruction: [...voucherData.instruction, newStatement],
          });
        } else {
          let newArr = [...voucherData.instruction];
          newArr[index].statement = e;
          setVoucherData({
            ...voucherData,
            instruction: newArr,
          });
        }
      } else {
        const newStatement = {
          statement: e,
          languageCode: locale,
        };
        setVoucherData({
          ...voucherData,
          instruction: [...voucherData.instruction, newStatement],
        });
      }
    }
  };

  const handleChangeTags = (selectedTags) => {
    if (selectedTags.filter((elem) => elem.value === 'Add own tag').length === 0) {
      setselectedTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);

      setVoucherData({
        ...voucherData,
        searchTags: tagsArr,
      });
    } else {
      setshowselect(false);
      setSearchTag(true);
      setAddTagModel(!addTagModel);
    }
  };

  const handleReportingTags = (selectedTags) => {
    if (selectedTags.filter((elem) => elem.value === 'Add own tag').length === 0) {
      setSelectedReportingTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setVoucherData({
        ...voucherData,
        reportingTags: tagsArr,
      });
    } else {
      setshowselect(false);
      setSearchTag(false);
      setAddTagModel(!addTagModel);
    }
  };
  const handleMemberShipTags = (selectedTags) => {    
    if (selectedTags.filter((elem) => elem.value === 'Add membership').length === 0) {
      setSelectedMembershipTags(selectedTags);
      const tagsArr = selectedTags.map((elem) => elem.value);
      setVoucherData({
        ...voucherData,
        membershipTags: tagsArr,
      });
    } else {
      setshowselect(false);
      setSearchTag(false);
      setAddMemberShipModal(!addMemberShipModal);
    }
  };
  const onTaxChange = (e) => {
    // setVoucherData({ ...voucherData, taxIncluded: e.target.value });    
    let val = parseFloat(voucherData.price) + parseFloat(e.target.value === 'true' ? 0 : 0);
    let val1 = 0;
    if (e.target.value === 'true') {
      let amount = ((parseFloat(voucherData.taxPercentage) + 100) / 100).toFixed(2);
      let tax = parseFloat(voucherData.price / amount).toFixed(2);
      val1 = parseFloat(voucherData.price - tax).toFixed(2);
    } else {
      val1 = (
        (parseFloat(voucherData.discountedPrice) * parseFloat(voucherData.taxPercentage)) /
        100
      ).toFixed(2);
    }
    let discountedPrice = Math.round(
      (parseFloat(voucherData.price) + parseFloat(e.target.value === 'true' ? 0 : 0)) -
      (((parseFloat(voucherData.price) + parseFloat(e.target.value === 'true' ? 0 : 0)) * parseFloat(voucherData.discount)) / 100)

    );
    setVoucherData({
      ...voucherData,
      taxAmount: val1,
      taxIncluded: e.target.value,
      discountedPrice: discountedPrice

    });

    // handleTaxAmount(voucherData.taxPercentage);
    // voucherData.taxIncluded = e.target.value;
  }
  const handleChange = (e) => {
    if (e.target.name === 'discount' && e.target.value !== '') {
      let val = parseFloat(voucherData.price) + parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0);
      let val1 = 0;
      if (voucherData.taxIncluded === 'true') {
        let amount = ((parseFloat(voucherData.taxPercentage) + 100) / 100).toFixed(2);
        let tax = parseFloat(voucherData.price / amount).toFixed(2);
        val1 = parseFloat(voucherData.price - tax).toFixed(2);
      } else {
        val1 = (
          (parseFloat(voucherData.discountedPrice) * parseFloat(voucherData.taxPercentage)) /
          100
        ).toFixed(2);
      }
      setVoucherData({
        ...voucherData,
        [e.target.name]: e.target.value,
        taxAmount: val1,
        discountedPrice: Math.round(
          (parseFloat(voucherData.price) + parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0)) -
          ((val * parseFloat(e.target.value)) / 100)
        ),
      });

    } else if (e.target.name === 'price' && e.target.value !== '') {
      let val = 0;
      if (voucherData.taxIncluded === 'true') {
        let amount = ((parseFloat(voucherData.taxPercentage) + 100) / 100).toFixed(2);
        let tax = parseFloat(e.target.value / amount).toFixed(2);
        val = parseFloat(e.target.value - tax).toFixed(2);
      } else {
        val = (
          (parseFloat(voucherData.discountedPrice) * parseFloat(voucherData.taxPercentage)) /
          100
        ).toFixed(2);
      }
      let totalprice = parseFloat(e.target.value) + parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0);
      setVoucherData({
        ...voucherData,
        [e.target.name]: e.target.value,
        taxAmount: val,
        discountedPrice: Math.round(
          totalprice -
          (totalprice * parseFloat(voucherData.discount) /
            100)
        ),
      });

    } else {
      setVoucherData({
        ...voucherData,
        [e.target.name]: e.target.value,
      });
    }

  };

  const handleSubmit = () => {

    if (id === undefined) {
      if (voucherData.startDayValidity != 1 || voucherData.startMonthValidity != 1 ||
        voucherData.endMonthValidity != 12 || voucherData.endDayValidity != 31) {
        voucherData.showValidityPeriod = true
      }
    }

    if (voucherData.name[0].statement === '' || voucherData.conditions[0].statement === '' || voucherData.details[0].statement === '' ||
      voucherData.totalPurchaseLimit === 0 || voucherData.orderPurchaseLimit === 0 || voucherData.price === 0 ||
      voucherData.instruction[0].statement === '<p><br></p>' ||
      voucherData.conditions[0].statement === '<p><br></p>' || voucherData.name[0].statement === '<p><br></p>' || voucherData.taxAmount === '' || (voucherData.taxIncluded === '' && voucherData.taxIncluded !== false)
    ) {
      seterror(true);
      voucherData.status = 'Draft';
    }
    else
      submit(voucherData);
  };

  const handleImageChange = (e, index) => {
    e.persist();
    const newItems = [...voucherData.images];
    newItems[index][e.target.name] = e.target.value;
    setVoucherData({
      ...voucherData,
      images: newItems,
    });
  };

  const handleIconChange = (e, index) => {
    e.persist();
    const newItems = [...voucherData.icons];
    newItems[index][e.target.name] = e.target.value;
    setVoucherData({
      ...voucherData,
      icons: newItems,
    });
  };

  const closeColorPicker = (e) => {
    const newItems = [...voucherData.icons];
    newItems.map(m => m.isEditMode = false);    
    setVoucherData({
      ...voucherData,
      icons: newItems,
    });
  }

  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const deleteImage = (index) => {
    const values = [...voucherData.images];
    values.splice(index, 1);
    setVoucherData({ ...voucherData, images: values });
  };

  const addImage = () => {
    const values = [...voucherData.images];
    values.push({
      url: '',
      displayOrder: 0,
    });
    setVoucherData({ ...voucherData, images: values });
  };

  const deleteIcon = (index) => {
    closeColorPicker();
    const values = [...voucherData.icons];
    values.splice(index, 1);
    setVoucherData({ ...voucherData, icons: values });
  };

  const addIcon = () => {
    closeColorPicker();
    const values = [...voucherData.icons];
    values.push({
      url: '',
      title: '',
      color: ''
    });
    setVoucherData({ ...voucherData, icons: values });
  };

  const handleTaxAmount = (percentage) => {
    let val = 0;
    if (voucherData.taxIncluded === 'true') {
      let amount = ((parseFloat(percentage) + 100) / 100).toFixed(2);
      let tax = parseFloat(voucherData.price / amount).toFixed(2);
      val = parseFloat(voucherData.price - tax).toFixed(2);
    } else {
      val = (
        (parseFloat(voucherData.discountedPrice) * parseFloat(percentage)) /
        100
      ).toFixed(2);

    }
    let discountedPrice = Math.round(
      (parseFloat(voucherData.price) +
        parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0)) -
      (((parseFloat(voucherData.price) +
        parseFloat(voucherData.taxIncluded === 'true' ? 0 : 0)) * parseFloat(voucherData.discount)) / 100)
    );
    setVoucherData({ ...voucherData, taxPercentage: percentage, taxAmount: val, discountedPrice: discountedPrice });
  }
  const ImageGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={galleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={togglegallery}>
                  Select Image or Upload New Image

                </ModalHeader>
                <ModalBody>
                  <ImageGallery
                    selectedImage={selectedImage}
                    togglegallery={togglegallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  const IconGalleryButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal
                isOpen={iconGalleryVisible}
                toggle={togglegallery}
                style={{ maxWidth: '1000px' }}
              >
                <ModalHeader toggle={toggleIcongallery}>
                  Select Icon or Upload New Icon

                </ModalHeader>
                <ModalBody>
                  <IconGallery
                    selectedImage={selecedIcon}
                    togglegallery={toggleIcongallery}
                    hideUserUploads={false}
                    searchText={''}
                  />
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };


  const handleAddIncludedItems = (name) => {
    if (voucherData.includedItems.split(',').includes(name.trim(''))) {
      let includeItemsList = voucherData.includedItems.split(',');
      let itemsList = includeItemsList.filter((e) => e !== name);
      setVoucherData({
        ...voucherData,
        includedItems: itemsList.toString(),
      });
    } else {
      setVoucherData({
        ...voucherData,
        includedItems: voucherData.includedItems + ',' + name,
      });
    }
  };
  const handleOptionInputChange = (name, event, optionId) => {
    switch (name) {
      case 'noOfAdults':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.noOfAdults = event;
            return m;
          }),
        });
        break;
      case 'noOfChildren':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.noOfChildren = event;
            return m;
          }),
        });
        break;
      case 'noOfNights':

        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.noOfNights = event;
            return m;
          }),
        });
        break;
      case 'noOfRooms':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.noOfRooms = event;
            return m;
          }),
        });
        break;
      case 'promoCode':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.promoCode = event;
            return m;
          }),
        });
        break;
      case 'couponId':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            if (m.id === optionId) {
              m.roomSettings.couponId = event;
            }
            return m;
          }),
        });
        break;
      case 'redeemOption':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.redeemOption = event;
            return m;
          }), redeemOption: event
        });
        break;
      case 'travelStartDate':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.travelStartDate = event;
            return m;
          }),
        });
        break;
      case 'travelEndDate':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.travelEndDate = event;
            return m;
          }),
        });
        break;
      case 'bookingStartDate':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {
            m.roomSettings.bookingStartDate = event;
            return m;
          }),
        });
        break;

      case 'noOfChildrenOperator':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {

            m.roomSettings.noOfChildrenOperator = event;

            return m;
          }),
        });
        break;

      case 'noOfAdultsOperator':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {

            m.roomSettings.noOfAdultsOperator = event;

            return m;
          }),
        });
        break;

      case 'bookingEndDate':

        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {

            m.roomSettings.bookingEndDate = event;
            return m;
          }),
        });
        break;
      case 'day':
        setVoucherData({
          ...voucherData,
          sellingOptions: voucherData.sellingOptions.map((m) => {

            m.roomSettings.days = event + ",";
            return m;
          }),
        });
        break;
      default:
        break;
    }
  };
  const handleAvailableDays = (name, optionId) => {
    setVoucherData({
      ...voucherData,
      sellingOptions: voucherData.sellingOptions.map((m) => {
        if (m.roomSettings.days.split(',').includes(name.trim(''))) {
          let includeItemsList = m.roomSettings.days.split(',');
          let itemsList = includeItemsList.filter((e) => e !== name);
          m.roomSettings.days = itemsList.toString();
        } else {
          m.roomSettings.days = m.roomSettings.days + ',' + name;

        }

        return m;
      }),
    });

  }
  const handleLocation = (e) => {
    setVoucherData({
      ...voucherData,
      location: e.target.value,
    });
  };
  const toggleToolTip = () => {
    setTooltipOpen(!tooltipOpen);
  };

  const handleAddCurrencies = () => {
    let lst = [...voucherData.currencies];
    lst.push({
      currency: 'USD',
      price: 0,
      discount: 0,
      discountedPrice: 0,
    });
    setVoucherData({ ...voucherData, currencies: lst });
  }

  const handleRemoveCurrencies = (val) => {
    let lst = [...voucherData.currencies];
    lst = lst.filter((f, index) => index !== val);
    setVoucherData({ ...voucherData, currencies: lst });
  }

  const handleCurrencyPrice = (e, val) => {
    let lst = [...voucherData.currencies];
    lst.map((m, index) => {
      if (index === val) {
        if (m.discount === 0) {
          m.price = e.target.value;
          m.discountedPrice = e.target.value;
        } else {
          m.price = e.target.value;
          m.discountedPrice = e.target.value - ((e.target.value * m.discount) / 100);
        }
      }
    });
    setVoucherData({ ...voucherData, currencies: lst });
  }

  const handleCurrencyDiscount = (e, val) => {
    let lst = [...voucherData.currencies];
    lst.map((m, index) => {
      if (index === val) {
        if (e.target.value === 0) {
          m.discount = m.price;
          m.discountedPrice = m.price;
        } else {
          m.discount = e.target.value;
          m.discountedPrice = m.price - ((m.price * e.target.value) / 100);
        }
      }
    });
    setVoucherData({ ...voucherData, currencies: lst });
  }

  const handleCurrency = (e, val) => {
    let lst = [...voucherData.currencies];
    lst.map((m, index) => {
      if (index === val)
        m.currency = e.target.value;
    });
    setVoucherData({ ...voucherData, currencies: lst });
  }

  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(process.env.REACT_APP_VOUCHER_URL + "/vhp?id=" + voucherData.id);
    NotificationManager.success(
      "",
      "Copy to clipboard successfully",
      3000,
      null,
      null,
      "success"
    );
  }

  return (
    <Fragment>
      <Modal
        isOpen={visible}
        toggle={toggle}
        size="lg"
        style={{ maxWidth: '1000px', right: `${id !== undefined ? "7rem" : "0rem"}` }}
      >
        <ModalHeader toggle={toggle}>
          <div class="row mt-1 text-left" style={{ width: '900px' }}>
            <div className='col-md-6 mt-2'>
              {formLabel}
            </div>
            <div className='col-md-6 d-none'>
              <div className='mr-2 mt-2'>Need inspiration?</div>
              <Button color={!showReviewVoucherList ? 'primary' : 'secondary'} className="text-white"
                onClick={() => {
                  setIsLoading(true); setShowReviewVoucherList(!showReviewVoucherList); setInterval(() => {
                    setIsLoading(false);
                  }, 1200);
                }}
                style={{ background: 'gray' }}>
                <span className='ml-2'>{!showReviewVoucherList ? "View Examples" : "Close"} <i className='iconsminds-share'></i></span>
              </Button>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          {loading === false ?
            <Fragment>
              <Row className="mb-4">
                <Colxx xxs="12">
                  {/* <pre>{JSON.stringify(voucherData, null, 2)}</pre> */}
                  <Row>
                    <Colxx sm={6} className="mb-3">
                      <Label>Title<span style={{ color: 'red' }}> *</span></Label>
                      <InputGroup>
                        <Input
                          type="textarea"
                          maxLength={50}
                          value={getLocalStatement(voucherData.name)}
                          onChange={handleChangeNameArr}
                          name="name"
                          style={{ height: '50px' }}
                        /><InputGroupAddon addonType="append">
                          <InputGroupText>{50 - getLocalStatement(voucherData.name).length}</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Colxx>
                    <Colxx sm={6} className="mb-3">
                      <Label>Summary (Optional)</Label>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(voucherData.introduction)}
                        onChange={(content, delta, source) =>
                          handleChangeIntroductionArr(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="introduction"

                      />
                    </Colxx>                                  
                    <Colxx sm={6} className="mb-3">
                      <Label>Details<span style={{ color: 'red' }}> *</span></Label>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(voucherData.details)}
                        onChange={(content, delta, source) =>
                          handleChangeDetailsArr(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="details"
                      />
                    </Colxx>
                    <Colxx sm={6} className="mb-3">
                      <Label>Conditions<span style={{ color: 'red' }}> *</span></Label>
                      <ReactQuill
                        theme="snow"
                        value={getLocalStatement(voucherData.conditions)}
                        onChange={(content, delta, source) =>
                          handleChangeConditionsArr(source, content)
                        }
                        modules={quillModules}
                        formats={quillFormats}
                        name="conditions"
                      />
                    </Colxx>

                    {/* <Colxx sm={6} className="mb-3">
                  <Label>Instructions</Label>
                  {<ReactQuill
                    theme="snow"
                    value={getLocalStatement(voucherData.instruction)}
                    onChange={(content, delta, source) =>
                      handleChangeInstructionsArr(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="instruction"
                  />}
                </Colxx> */}

                    {/* <Colxx sm={3} className="mb-3">
                  <Label>Primary Business Category<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={
                      voucherData.category === undefined || null
                        ? 'Wine'
                        : voucherData.category
                    }
                    name="category"
                    onChange={(f) => {
                      setVoucherData({
                        ...voucherData,
                        category: f.target.value,
                      });
                    }}
                  >
                    {CatgeoryData.data !== undefined &&
                      CatgeoryData.data.map((m) => {
                        return <option value={m.value}>{m.name}</option>;
                      })}
                  </Input>
                </Colxx> */}

                    {/* <Colxx sm={3} className="mb-3">
                  <Label>Hide Price</Label>
                  <CustomInput
                    type="checkbox"
                    id="hidePrice"
                    checked={voucherData.hidePrice}
                    name="hidePrice"
                    onChange={handleCheckChange}
                  />
                </Colxx> */}

                    <Colxx sm={3} style={{ display: 'none' }}>
                      <Label for="displayOrder">Location</Label>
                      <Input
                        type="text"
                        name="displayOrder"
                        min={0}
                        value={voucherData.location}
                        onChange={handleLocation}
                      />
                    </Colxx>
                  </Row>

                  <Row className="mb-2">
                    <Colxx sm={12}>
                      <h4>Optional Icons For What`s Included</h4>
                    </Colxx>
                    <Colxx sm={12}>
                      {voucherData.icons.length > 0 &&
                        voucherData.icons.map((image, index) => (
                          <Row key={`${image}~${index}`} onClick={(e) => { e.stopPropagation(); }}>
                            <Colxx sm={2} className="md-3" >
                              <img
                                style={{
                                  width: '70px',
                                  height: '70px',
                                }}
                                alt="room image"
                                src={
                                  image.url || 'https://via.placeholder.com/150/'
                                }
                              />
                            </Colxx>

                            <Colxx sm={3} className="mb-3" >
                              <Label>Title</Label>
                              <Input
                                type="text"
                                name="title"
                                value={image.title}
                                onChange={(event) =>
                                  handleIconChange(event, index)
                                }
                              />
                            </Colxx>
                            {/* <Colxx sm={3} className="mb-3">
                              <Label>Color</Label>
                              <Row>
                                <div className='col-md-12'>
                                  <InputGroup>
                                    <Input
                                      className=""
                                      type="text"
                                      name="color"
                                      onChange={(e) => handleIconChange(e, index)}
                                      value={image.color}
                                    />
                                    <InputGroupAddon addonType="append">
                                      <InputGroupText onClick={() => {
                                        let icons = [...voucherData.icons];
                                        icons[index].isEditMode = true;
                                        setVoucherData({ ...voucherData, icons: icons });
                                      }
                                      } className="color-square" style={setBackGroundColor(image.color)}></InputGroupText>
                                    </InputGroupAddon>
                                  </InputGroup>
                                </div>
                              </Row>
                              {(image.isEditMode !== undefined && image.isEditMode === true) &&
                                <div className='parent-div' style={{ position: 'absolute', zIndex: '9999' }}>
                                  <div className='cover'>
                                    <ChromePicker disableAlpha={true} className='ml-2'
                                      style={{ width: '240px' }}
                                      color={image.color}
                                      onChangeComplete={(e) => {
                                        let icons = [...voucherData.icons];
                                        icons[index].color = e.hex;
                                        setVoucherData({ ...voucherData, icons: icons });
                                      }
                                      }
                                    />
                                  </div>
                                </div>}
                            </Colxx> */}
                            <Colxx sm={1} className="mb-3" >
                              <Label>Browse</Label>
                              <div
                                className="iconsminds-photo"
                                onClick={(e) => { toggleIcongallery(index) }}
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '28px',
                                  color: '#73236b',
                                }}
                              ></div>
                            </Colxx>
                            <Colxx sm={1} className="mb-3">
                              <Label>Remove</Label>
                              <div>
                                <Button
                                  onClick={(e) => { e.stopPropagation(); deleteIcon(index) }}
                                  color="secondary"
                                  size="xs"
                                  outline
                                  style={{ margin: '6px' }}
                                >
                                  -
                                </Button>
                              </div>
                            </Colxx>
                          </Row>
                        ))}
                    </Colxx>
                    <Colxx sm={12}>
                      <Button
                        onClick={addIcon}
                        color="primary"
                        size="xs"
                        outline
                        style={{ margin: '6px' }}
                      >
                        + Add Icon
                      </Button>
                    </Colxx>
                  </Row>

                  <Row className="mb-2">
                    <Colxx sm={12}>
                      <h4>Images</h4>
                    </Colxx>
                    <Colxx sm={12}>
                      {voucherData.images.length > 0 &&
                        voucherData.images.map((image, index) => (
                          <Row key={`${image}~${index}`}>
                            <Colxx sm={2} className="md-3">
                              <img
                                style={{
                                  width: '100%',
                                  height: '90%',
                                }}
                                alt="room image"
                                src={
                                  image.url || 'https://www.digitalseotool.com/placeholder/600x480/d5d5d5/584959'
                                }
                              />
                            </Colxx>

                            <Colxx sm={3} className="mb-3">
                              <Label>Image Display Order</Label>
                              <Input
                                type="number"
                                name="displayOrder"
                                min={1}
                                value={image.displayOrder}
                                onChange={(event) =>
                                  handleImageChange(event, index)
                                }
                              />
                            </Colxx>
                            <Colxx sm={1} className="mb-3">
                              <Label>Browse</Label>
                              <div
                                className="iconsminds-photo"
                                onClick={(event) => togglegallery(index)}
                                style={{
                                  cursor: 'pointer',
                                  fontSize: '28px',
                                  color: '#73236b',
                                }}
                              ></div>
                            </Colxx>
                            <Colxx sm={1} className="mb-3">
                              <Label>Remove</Label>
                              <div>
                                <Button
                                  onClick={() => deleteImage(index)}
                                  color="secondary"
                                  size="xs"
                                  outline
                                  style={{ margin: '6px' }}
                                >
                                  -
                                </Button>
                              </div>
                            </Colxx>
                          </Row>
                        ))}
                    </Colxx>
                    <Colxx sm={12}>
                      <Button
                        onClick={addImage}
                        color="primary"
                        size="xs"
                        outline
                        style={{ margin: '6px' }}
                      >
                        + Add image
                      </Button>
                    </Colxx>
                  </Row>

                  {/* <Row className="my-3">
                    <Colxx sm={12}>
                      <h4>What`s Included ?</h4>
                    </Colxx>
                    <Colxx sm={12}>
                      <Row className="mb-4">
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Night Stay')
                                ? true
                                : false
                            }
                            value="Night Stay"
                            onChange={() => handleAddIncludedItems('Night Stay')}
                          >
                            <span style={{ lineHeight: '23px' }}>Night Stay</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Breakfast')
                                ? true
                                : false
                            }
                            value="Breakfast"
                            onChange={() => handleAddIncludedItems('Breakfast')}
                          >
                            <span style={{ lineHeight: '23px' }}>Breakfast</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Bike Hire')
                                ? true
                                : false
                            }
                            value="Bike Hire"
                            onChange={() => handleAddIncludedItems('Bike Hire')}
                          >
                            <span style={{ lineHeight: '23px' }}>Bike Hire</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Drinks')
                                ? true
                                : false
                            }
                            value="Drinks"
                            onChange={() => handleAddIncludedItems('Drinks')}
                          >
                            <span style={{ lineHeight: '23px' }}>Drinks</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Pool')
                                ? true
                                : false
                            }
                            value="Pool"
                            onChange={() => handleAddIncludedItems('Pool')}
                          >
                            <span style={{ lineHeight: '23px' }}>Pool</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Shopping')
                                ? true
                                : false
                            }
                            value="Shopping"
                            onChange={() => handleAddIncludedItems('Shopping')}
                          >
                            <span style={{ lineHeight: '23px' }}>Shopping</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('High Tea')
                                ? true
                                : false
                            }
                            value="High Tea"
                            onChange={() => handleAddIncludedItems('High Tea')}
                          >
                            <span style={{ lineHeight: '23px' }}>High Tea</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Golf')
                                ? true
                                : false
                            }
                            value="Golf"
                            onChange={() => handleAddIncludedItems('Golf')}
                          >
                            <span style={{ lineHeight: '23px' }}>Golf</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Restaurant')
                                ? true
                                : false
                            }
                            value="Restaurant"
                            onChange={() => handleAddIncludedItems('Restaurant')}
                          >
                            <span style={{ lineHeight: '23px' }}>Restaurant</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Room')
                                ? true
                                : false
                            }
                            value="Room"
                            onChange={() => handleAddIncludedItems('Room')}
                          >
                            <span style={{ lineHeight: '23px' }}>Room</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Beach Access')
                                ? true
                                : false
                            }
                            value="Beach Access"
                            onChange={() => handleAddIncludedItems('Beach Access')}
                          >
                            <span style={{ lineHeight: '23px' }}>Beach Access</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems
                                .split(',')
                                .includes('Camping Site')
                                ? true
                                : false
                            }
                            value="Camping Site"
                            onChange={() => handleAddIncludedItems('Camping Site')}
                          >
                            <span style={{ lineHeight: '23px' }}>Camping Site</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Ski')
                                ? true
                                : false
                            }
                            value="Ski"
                            onChange={() => handleAddIncludedItems('Ski')}
                          >
                            <span style={{ lineHeight: '23px' }}>Ski</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Parking')
                                ? true
                                : false
                            }
                            value="Parking"
                            onChange={() => handleAddIncludedItems('Parking')}
                          >
                            <span style={{ lineHeight: '23px' }}>Parking</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Transfers')
                                ? true
                                : false
                            }
                            value="Transfers"
                            onChange={() => handleAddIncludedItems('Transfers')}
                          >
                            <span style={{ lineHeight: '23px' }}>Transfers</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Pets Allowed')
                                ? true
                                : false
                            }
                            value="Pets Allowed"
                            onChange={() => handleAddIncludedItems('Pets Allowed')}
                          >
                            <span style={{ lineHeight: '23px' }}>Pets Allowed</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Sauna/Hot Tub')
                                ? true
                                : false
                            }
                            value="Sauna/Hot Tub"
                            onChange={() => handleAddIncludedItems('Sauna/Hot Tub')}
                          >
                            <span style={{ lineHeight: '23px' }}>Sauna/Hot Tub</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Massage')
                                ? true
                                : false
                            }
                            value="Massage"
                            onChange={() => handleAddIncludedItems('Massage')}
                          >
                            <span style={{ lineHeight: '23px' }}>Massage</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Dailydelegate')
                                ? true
                                : false
                            }
                            value="Dailydelegate"
                            onChange={() => handleAddIncludedItems('Dailydelegate')}
                          >
                            <span style={{ lineHeight: '23px' }}>Daily delegate</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Latecheckout')
                                ? true
                                : false
                            }
                            value="Latecheckout"
                            onChange={() => handleAddIncludedItems('Latecheckout')}
                          >
                            <span style={{ lineHeight: '23px' }}>Late check out</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Shuttleride')
                                ? true
                                : false
                            }
                            value="Shuttleride"
                            onChange={() => handleAddIncludedItems('Shuttleride')}
                          >
                            <span style={{ lineHeight: '23px' }}>Shuttle ride</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Diving')
                                ? true
                                : false
                            }
                            value="Diving"
                            onChange={() => handleAddIncludedItems('Diving')}
                          >
                            <span style={{ lineHeight: '23px' }}>Diving</span>
                          </CustomInput>
                        </Colxx>
                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('DivingEquipment')
                                ? true
                                : false
                            }
                            value="DivingEquipment"
                            onChange={() => handleAddIncludedItems('DivingEquipment')}
                          >
                            <span style={{ lineHeight: '23px' }}>Diving Equipment</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Facial')
                                ? true
                                : false
                            }
                            value="Facial"
                            onChange={() => handleAddIncludedItems('Facial')}
                          >
                            <span style={{ lineHeight: '23px' }}>Facial</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Salon')
                                ? true
                                : false
                            }
                            value="Salon"
                            onChange={() => handleAddIncludedItems('Salon')}
                          >
                            <span style={{ lineHeight: '23px' }}>Salon</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Hiking')
                                ? true
                                : false
                            }
                            value="Hiking"
                            onChange={() => handleAddIncludedItems('Hiking')}
                          >
                            <span style={{ lineHeight: '23px' }}>Hiking</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('FitnessClub')
                                ? true
                                : false
                            }
                            value="FitnessClub"
                            onChange={() => handleAddIncludedItems('FitnessClub')}
                          >
                            <span style={{ lineHeight: '23px' }}>Fitness Club</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('helicopterRide')
                                ? true
                                : false
                            }
                            value="helicopterRide"
                            onChange={() => handleAddIncludedItems('helicopterRide')}
                          >
                            <span style={{ lineHeight: '23px' }}>Helicopter Ride</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('boatRamp')
                                ? true
                                : false
                            }
                            value="boatRamp"
                            onChange={() => handleAddIncludedItems('boatRamp')}
                          >
                            <span style={{ lineHeight: '23px' }}>Boat Ramp</span>
                          </CustomInput>
                        </Colxx>


                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Laundry')
                                ? true
                                : false
                            }
                            value="Laundry"
                            onChange={() => handleAddIncludedItems('Laundry')}
                          >
                            <span style={{ lineHeight: '23px' }}>Laundry</span>
                          </CustomInput>
                        </Colxx>

                        <Colxx sm={3}>
                          <CustomInput
                            type="checkbox"
                            checked={
                              voucherData.includedItems.split(',').includes('Skyjump')
                                ? true
                                : false
                            }
                            value="Skyjump"
                            onChange={() => handleAddIncludedItems('Skyjump')}
                          >
                            <span style={{ lineHeight: '23px' }}>Skyjump</span>
                          </CustomInput>
                        </Colxx>

                      </Row>
                    </Colxx>

                  </Row> */}

                  <Row className="mb-2">
                    {showselect === true && <Colxx sm={3} className="mb-3">
                      <Label for="displayOrder">Display Order</Label>
                      <Input
                        type="number"
                        name="displayOrder"
                        min={0}
                        value={voucherData.displayOrder}
                        onChange={handleChange}
                      />
                    </Colxx>}
                    <Colxx sm={6}>
                      <FormGroup>
                        <Label for="bookingUrl">Customer Search Tags</Label>
                        <Select
                          components={{ Input: CustomSelectInput }}
                          className="react-select"
                          classNamePrefix="react-select"
                          isMulti={true}
                          name="form-field-name"
                          value={selectedTags}
                          onChange={handleChangeTags}
                          options={tags}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>

                  <Row className="mb-2">
                    <Colxx sm={12}>
                      <h4>Applicability Conditions</h4>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Status<span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        type="select"
                        value={voucherData.status}
                        name="status"
                        onChange={handleChange}
                      >
                        <option value="ActiveMembers">Active - Members Only</option>
                        <option value="Draft">Draft</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                        <option value="Archived">Archived</option>
                      </Input>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Sell Start Dates<span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        required
                        type="date"
                        name="startDate"
                        value={moment(voucherData.startDate).format('YYYY-MM-DD')}
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Sell End Dates<span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        required
                        type="date"
                        name="expiryDate"
                        value={moment(voucherData.expiryDate).format('YYYY-MM-DD')}
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Expiry After Purchase</Label>
                      <Input
                        type="select"
                        value={voucherData.expiryAfterPurchase}
                        name="expiryAfterPurchase"
                        onChange={handleChange}
                      >
                        <option value="6">6 Months</option>
                        <option value="12">12 Months</option>
                        <option value="24">24 Months</option>
                        <option value="36">36 Months</option>
                        <option value="48">48 Months</option>
                        <option value="60">60 Months</option>
                        <option value="-1">Never Expires</option>
                        <option value="0">Custom Date</option>
                      </Input>
                    </Colxx>
                    {voucherData.expiryAfterPurchase == 0 && <Colxx sm={3} className="mb-3">
                      <Label>Expiry After Purchase Date</Label>
                      <Input
                        type="date"
                        value={moment(voucherData.ownExpiryDate).format('YYYY-MM-DD')}
                        name="ownExpiryDate"
                        onChange={handleChange}
                      >
                      </Input>
                    </Colxx>}

                    <Colxx sm={12} className="mb-3">

                      <Row>
                        <Colxx sm={6} className="mb-3">
                          <Label>Redeem Validity Period</Label>
                          <Row>
                            <Colxx sm={6} className="mb-3">
                              <div className='d-flex'>
                                <Input
                                  type="select"
                                  style={{ width: '50%' }}
                                  value={voucherData.startDayValidity}
                                  name="startDayValidity"
                                  onChange={handleChange}
                                >
                                  {dayValidity.length > 0 && dayValidity.map((m) => <option value={m}>{m}</option>)}
                                </Input>
                                <Input
                                  type="select"
                                  style={{ width: '50%' }}
                                  value={voucherData.startMonthValidity}
                                  name="startMonthValidity"
                                  onChange={handleChange}
                                >
                                  {monthValidity.length > 0 && monthValidity.map((m) => <option value={m.val}>{m.label}</option>)}
                                </Input>
                                <Input
                                  type="select"
                                  style={{ width: '50%' }}
                                  value={voucherData.startYearValidity}
                                  name="startYearValidity"
                                  onChange={handleChange}
                                >
                                  {voucherData.startYearValidity == 0 &&
                                    <option value={0}></option>
                                  }
                                  {yearValidity.length > 0 && yearValidity.map((m) => <option value={m}>{m}</option>)}
                                </Input>
                              </div>
                            </Colxx>
                            <Colxx sm={6} className="mb-3">
                              <div className='d-flex'>
                                <Input
                                  type="select"
                                  style={{ width: '50%' }}
                                  value={voucherData.endDayValidity}
                                  name="endDayValidity"
                                  onChange={handleChange}
                                >
                                  {dayValidity.length > 0 && dayValidity.map((m) => <option value={m}>{m}</option>)}
                                </Input>
                                <Input
                                  type="select"
                                  style={{ width: '50%' }}
                                  value={voucherData.endMonthValidity}
                                  name="endMonthValidity"
                                  onChange={handleChange}
                                >
                                  {monthValidity.length > 0 && monthValidity.map((m) => <option value={m.val}>{m.label}</option>)}
                                </Input>
                                <Input
                                  type="select"
                                  style={{ width: '50%' }}
                                  value={voucherData.endYearValidity}
                                  name="endYearValidity"
                                  onChange={handleChange}
                                >
                                  {voucherData.endYearValidity == 0 &&
                                    <option value={0}></option>
                                  }

                                  {yearValidity.length > 0 && yearValidity.map((m) => <option value={m}>{m}</option>)}
                                </Input>
                              </div>
                            </Colxx>
                          </Row>


                        </Colxx>

                      </Row>

                      <Row>
                        {voucherData.isMemberShip === true && showselect === true && <Colxx sm={6}>
                          <FormGroup>
                            <Label for="bookingUrl">Membership Name</Label>
                            <Select
                              components={{ Input: CustomSelectInput }}
                              className="react-select"
                              classNamePrefix="react-select"
                              isMulti={true}
                              name="form-field-name"
                              value={selectedMemberShipTags}
                              onChange={handleMemberShipTags}
                              options={membershipTags}
                            />
                          </FormGroup>
                        </Colxx>}
                        <Colxx sm={3} className="mb-3">
                          <Label>Members Only</Label>
                          <CustomInput
                            type="checkbox"
                            id="isMemberShip"
                            checked={voucherData.isMemberShip}
                            name="isMemberShip"
                            onChange={(e) => setVoucherData({
                              ...voucherData, isMemberShip: e.target.checked
                            })}
                          />
                        </Colxx>
                      </Row>
                      <Row>
                        {showselect === true && <Colxx sm={6}>
                          <FormGroup>
                            <Label for="bookingUrl">Internal Reporting Tags</Label>
                            <Select
                              components={{ Input: CustomSelectInput }}
                              className="react-select"
                              classNamePrefix="react-select"
                              isMulti={true}
                              name="form-field-name"
                              value={selectedReportingTags}
                              onChange={handleReportingTags}
                              options={reportingTags}
                            />
                          </FormGroup>
                        </Colxx>}
                      </Row>

                      <Row>
                        <Colxx sm={3} className="mb-3">
                          <Label>Allow Gifting</Label>
                          <CustomInput
                            type="checkbox"
                            id="giftEnabled"
                            checked={voucherData.giftEnabled}
                            name="giftEnabled"
                            onChange={handleCheckChange}
                          />
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                  <hr></hr>
                  <Row className="mb-2">
                    <Colxx sm={12}>
                      <h4>Voucher PDF</h4>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Print Redeem Validity Date on PDF</Label>
                      <CustomInput
                        type="checkbox"
                        id="showValidityPeriod"
                        checked={voucherData.showValidityPeriod}
                        name="showValidityPeriod"
                        onChange={handleCheckChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Print Expiry Date on PDF</Label>
                      <CustomInput
                        type="checkbox"
                        id="showExpiryDate"
                        checked={voucherData.showExpiryDate}
                        name="showExpiryDate"
                        onChange={handleCheckChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Print Voucher Terms</Label>
                      <CustomInput
                        type="checkbox"
                        id="printVoucherTerms"
                        checked={voucherData.printVoucherTerms}
                        name="printVoucherTerms"
                        onChange={handleCheckChange}
                      />
                    </Colxx>
                  </Row>

                  <hr></hr>
                  <Row className="mb-2">
                    <Colxx sm={12}>
                      <h4>Pricing & Inventory</h4>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Retail Price<span style={{ color: 'red' }}> *</span></Label>
                      <InputGroup>
                        <Input
                          type="number"
                          min={0}
                          value={voucherData.price}
                          name="price"
                          onChange={handleChange}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>{propertyData.currency}</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Discount</Label>
                      <InputGroup>
                        <Input
                          type="number"
                          min={0}
                          value={voucherData.discount}
                          name="discount"
                          onChange={(e) => { handleChange(e); }}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>%</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Price After Discount</Label>
                      <Input
                        disabled={true}
                        type="number"
                        min={0}
                        value={voucherData.discountedPrice}
                        name="discountedPrice"
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <FormGroup>
                        <Label>  <strong>aiva</strong> Processing Fee
                        </Label>
                        <InputGroup>

                          <Input
                            type="number"
                            name="bmbVoucherProcessingFee"
                            id="bmbVoucherProcessingFee"
                            onChange={handleChange}
                            disabled={true}
                            value={propertyData.bmbVoucherProcessingFee}
                          />
                          <InputGroupAddon addonType='append' >
                            <InputGroupText>%</InputGroupText>
                          </InputGroupAddon>
                        </InputGroup>

                      </FormGroup>
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Tax included in price <span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        type="select"
                        value={voucherData.taxIncluded}
                        name="taxIncluded"
                        onChange={(f) => {
                          onTaxChange(f);

                        }}
                      >
                        <option value='true' >Yes</option>
                        <option value='false'>No</option>
                      </Input>
                    </Colxx>
                    <Colxx sm={3}>
                      <Label for="tax_Percentage">Tax Percentage <span style={{ color: 'red' }}> *</span></Label>
                      <InputGroup>
                        <Input
                          type="text"
                          name="taxPercentage"
                          min={0}
                          value={voucherData.taxPercentage !== NaN ? voucherData.taxPercentage : 0}
                          onChange={(e) => {
                            handleTaxAmount(e.target.value);

                          }}
                        />
                        <InputGroupAddon addonType="append">
                          <InputGroupText>%</InputGroupText>
                        </InputGroupAddon>
                      </InputGroup>
                    </Colxx>
                    <Colxx sm={3} >
                      <Label for="tax_Amount">Tax Amount<span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        type="text"
                        disabled={true}
                        name="taxAmount"
                        min={0}
                        value={voucherData.taxAmount}
                        onChange={(e) => { setVoucherData({ ...voucherData, taxAmount: e.target.value }) }}
                      />
                    </Colxx>
                  </Row>

                  <Row className="mb-1">

                    <Colxx sm={3} className="mb-3">
                      <Label>Total Available to Sell<span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        type="number"
                        min={0}
                        value={voucherData.totalPurchaseLimit}
                        name="totalPurchaseLimit"
                        onChange={handleChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Order Purchase Limit<span style={{ color: 'red' }}> *</span></Label>
                      <Input
                        type="number"
                        min={0}
                        value={voucherData.orderPurchaseLimit}
                        name="orderPurchaseLimit"
                        onChange={handleChange}
                      />
                    </Colxx><Colxx sm={3} className="mb-3">
                      <Label>Enable Multiple Choices</Label>
                      <CustomInput
                        type="checkbox"
                        checked={voucherData.options}
                        name="options"
                        onChange={handleCheckChange}
                      />
                    </Colxx>
                    <Colxx sm={3} className="mb-3">
                      <Label>Manage Inventory at Choice Level</Label>
                      <CustomInput
                        type="checkbox"
                        checked={voucherData.inventoryOptionLevel}
                        name="inventoryOptionLevel"
                        onChange={handleCheckChange}
                      />
                    </Colxx>


                  </Row>

                </Colxx>




              </Row>

              {voucherData.currencies.length > 0 && voucherData.currencies.map((m, index) =>
                <Row className="mb-2">
                  <Colxx sm={3} className="mb-3">
                    <Label>Retail Price<span style={{ color: 'red' }}> *</span></Label>
                    <InputGroup>
                      <Input
                        type="number"
                        min={0}
                        value={m.price}
                        onChange={(e) => handleCurrencyPrice(e, index)}
                      />
                      <InputGroupAddon addonType="append">
                        <Input
                          type="select"
                          value={m.currency}
                          name="type"
                          onChange={(e) => handleCurrency(e, index)}
                        >
                          {StandaloneCurrency.map((elem, index) => (
                            <option value={elem.code}>{elem.code}</option>
                          ))}
                        </Input>
                      </InputGroupAddon>
                    </InputGroup>
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Discount<span style={{ color: 'red' }}> *</span></Label>
                    <Input
                      type="number"
                      min={0}
                      value={m.discount}
                      onChange={(e) => handleCurrencyDiscount(e, index)}
                    />
                  </Colxx>
                  <Colxx sm={3} className="mb-3">
                    <Label>Price After Discount<span style={{ color: 'red' }}> *</span></Label>
                    <Input
                      type="number"
                      disabled={true}
                      value={m.discountedPrice}
                    />
                  </Colxx>
                  <Colxx sm={2} className="mb-3">
                    <Label>Tax Amount<span style={{ color: 'red' }}> *</span></Label>
                    <Input
                      type="text"
                      disabled={true}
                      value={voucherData.taxAmount}
                    />
                  </Colxx>
                  <Colxx sm={1} className="mb-3 mt-3">
                    <Button color="danger" onClick={() => handleRemoveCurrencies(index)}>
                      X
                    </Button>
                  </Colxx>
                </Row>
              )}
              <Row className="mb-1">
                <Colxx sm={12} className="mb-3">
                  <Button color="secondary" onClick={() => handleAddCurrencies()}>
                    Add Currencies
                  </Button>
                </Colxx>
              </Row>
              <hr></hr>
              <Row className="mb-1">
                <Colxx sm={12} className="mb-2">
                  <h4>Redeem Instructions</h4>
                </Colxx>
                <Colxx sm={3} className="mb-3">
                  <Label>Redeem Mechanism<span style={{ color: 'red' }}> *</span></Label>
                  <Input
                    type="select"
                    value={voucherData.redeemOption}
                    name="redeemOption"
                    onChange={(f) => {
                      // setVoucherData({
                      //   ...voucherData,
                      //   redeemOption: f.target.value,
                      // });
                      handleOptionInputChange(
                        f.target.name,
                        f.target.value,
                        voucherData.sellingOptions[0].id
                      );
                    }}
                  >
                    <option
                      value="2"
                      selected={
                        voucherData.redeemOption === '2'
                          ? true
                          : false
                      }
                    >
                      Instructions
                    </option>
                    <option
                      value="3"
                      selected={
                        voucherData.redeemOption === '3'
                          ? true
                          : false
                      }
                    >
                      aiva Integrations
                    </option>
                    {amadeus !== undefined && <option
                      value="4"
                      selected={
                        voucherData.redeemOption === '4'
                          ? true
                          : false
                      }
                    >
                      Amadeus Integrations
                    </option>}
                    {mews !== undefined && <option
                      value="6"
                      selected={
                        voucherData.redeemOption === '5'
                          ? true
                          : false
                      }
                    >
                      Mews Integrations
                    </option>}
                    {xolaIntegration !== undefined && <option
                      value="6"
                      selected={
                        voucherData.redeemOption === '5'
                          ? true
                          : false
                      }
                    >
                      Xola Integrations
                    </option>}
                  </Input>
                </Colxx>
                {voucherData.redeemOption == 4 && <Colxx sm={3} className="mb-3">
                  <Label>Promo Code in Amadeus</Label>
                  <Input
                    type="text"
                    value={voucherData.sellingOptions[0] !== undefined && voucherData.sellingOptions[0].roomSettings.promoCode}
                    name="promoCode"
                    onChange={(event) =>
                      handleOptionInputChange(
                        event.target.name,
                        event.target.value,
                        voucherData.sellingOptions[0].id
                      )
                    }
                  />
                </Colxx>}
                {voucherData.redeemOption == 6 && <Colxx sm={3} className="mb-3">
                  <Label>Voucher Code in Mews</Label>
                  <Input
                    type="text"
                    value={voucherData.sellingOptions[0] !== undefined && voucherData.sellingOptions[0].roomSettings.promoCode}
                    name="promoCode"
                    onChange={(event) =>
                      handleOptionInputChange(
                        event.target.name,
                        event.target.value,
                        voucherData.sellingOptions[0].id
                      )
                    }
                  />
                </Colxx>}
                {voucherData.redeemOption == 5 && <Colxx sm={3} className="mb-3">
                  <Label><span className='mt-1'>Applicable coupon </span></Label>
                  <Input
                    type="select"
                    value={voucherData.couponId}
                    name="couponId"
                    onChange={(event) => {
                      handleOptionInputChange(
                        event.target.name,
                        event.target.value,
                        voucherData.sellingOptions[0].id
                      );
                      setVoucherData({
                        ...voucherData,
                        couponId: event.target.value,
                      });
                    }
                    }
                  >
                    <option value="-1">Select One</option>
                    {couponList !== undefined && couponList.length > 0 && couponList.map((m, index) =>
                      <option key={index} value={m.id}>{m.name}</option>
                    )}
                  </Input>
                </Colxx>}
              </Row>

              <Row>
                {(voucherData.redeemOption == 4) &&
                  <RoomSettings option={voucherData.sellingOptions[0]} handleOptionInputChange={handleOptionInputChange} Weekdays={Weekdays} handleAddIncludedItems={handleAvailableDays} />
                }
                {(voucherData.redeemOption == 6) &&
                  <RoomSettings mews={mews} option={voucherData.sellingOptions[0]} handleOptionInputChange={handleOptionInputChange} Weekdays={Weekdays} handleAddIncludedItems={handleAvailableDays} />
                }
                {voucherData.redeemOption == 4 && amadeus !== undefined && <Colxx sm={3} className="mb-3">
                  <Label><span className='mt-1'>Applicable room </span> <span id="roomtip" className='ml-1 mb-3 room-icon'><FontAwesomeIcon icon={faInfoCircle} ></FontAwesomeIcon></span></Label>
                  <Input
                    type="select"
                    value={voucherData.roomId}
                    name="room"
                    id='room'
                    onChange={(f) => {
                      setVoucherData({
                        ...voucherData,
                        roomId: f.target.value,
                      });
                    }}
                  >
                    <option value="-1">Select One</option>
                    {roomlst.length > 0 && roomlst.map((m) =>
                      <option value={m.id}>{m.roomTypeName}</option>
                    )}
                  </Input>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="roomtip"
                    toggle={toggleToolTip}
                  >
                    The room names are pulled from Amadeus. Please select the room that this voucher applies to.
                  </Tooltip>
                </Colxx>}
                {voucherData.redeemOption == 6 && mews !== undefined && <Colxx sm={3} className="mb-3">
                  <Label><span className='mt-1'>Applicable room </span> <span id="roomtip" className='ml-1 mb-3 room-icon'><FontAwesomeIcon icon={faInfoCircle} ></FontAwesomeIcon></span></Label>
                  <Input
                    type="select"
                    value={voucherData.roomId}
                    name="room"
                    id='room'
                    onChange={(f) => {                      
                      setVoucherData({
                        ...voucherData,
                        roomId: f.target.value,
                      });
                    }}
                  >
                    <option value="-1">Select One</option>
                    {mewsRoomList.length > 0 && mewsRoomList.map((m) =>
                      <option value={m.id}>{m.name['en-US']}</option>
                    )}
                  </Input>
                  <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target="roomtip"
                    toggle={toggleToolTip}
                  >
                    The room names are pulled from Amadeus. Please select the room that this voucher applies to.
                  </Tooltip>
                </Colxx>}
                <Colxx sm={4} className="d-none mb-3">
                  <FormGroup>
                    <Label>  Add Your Fee (for partner vouchers)
                    </Label>
                    <InputGroup>
                      <Input
                        type="number"
                        name="processingFee"
                        id="processingFee"
                        onChange={(f) => {
                          setVoucherData({
                            ...voucherData,
                            processingFee: f.target.value,
                          });
                        }}
                        value={processingFee !== undefined && processingFee !== '' ? parseFloat(processingFee) : parseFloat(voucherData.processingFee)}
                      />
                      <InputGroupAddon addonType='append' >
                        <InputGroupText>%</InputGroupText>
                      </InputGroupAddon>

                    </InputGroup>

                  </FormGroup>
                </Colxx>
                {voucherData.redeemOption === '2' && <Colxx sm={6} className="mb-3">
                  <Label>External Link (Url)</Label>
                  <Input
                    type="text"
                    value={voucherData.url}
                    name="url"
                    onChange={(f) => {
                      setVoucherData({ ...voucherData, url: f.target.value });
                    }}
                  />
                </Colxx>}
                {voucherData.redeemOption !== 'BookMeBob' && <Colxx sm={6} className="mb-3">
                  <Label>Instructions<span style={{ color: 'red' }}> *</span></Label>
                  <ReactQuill
                    theme="snow"
                    value={getLocalStatement(voucherData.instruction)}
                    onChange={(content, delta, source) =>
                      handleInstructions(source, content)
                    }
                    modules={quillModules}
                    formats={quillFormats}
                    name="instruction"
                  />
                </Colxx>}
              </Row>
              {isLoading && showReviewVoucherList &&
                <Spinner style={{ color: '#EF4A81' }} className="mb-1 preview-spinner" />
              }
            </Fragment> : <div className="mx-auto my-auto text-center">
              <Spinner style={{ color: '#EF4A81' }} className="mb-1" />
            </div>}
          {isHostedPageIntegration !== undefined && isHostedPageIntegration &&
            <Fragment>
              <hr></hr>

              <Row className="mb-1">
                {/* <Colxx sm={12} className="mb-2">
                  <h4>Redeem Instructions</h4>
                </Colxx> */}
                <Colxx sm={12}>
                  <FormGroup>
                    <Label for="displayOrder">Direct Voucher Link</Label>
                    <InputGroup>
                      <Input
                        type="text"
                        name="directLink"
                        value={process.env.REACT_APP_VOUCHER_URL + "/vhp?id=" + voucherData.id}
                        disabled={true}
                      /> <InputGroupAddon addonType='append' >
                        <InputGroupText> <FontAwesomeIcon style={{ cursor: 'pointer' }} icon={faCopy} onClick={() => handleCopyToClipboard()}></FontAwesomeIcon></InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </FormGroup>
                </Colxx>
              </Row>
            </Fragment>
          }
        </ModalBody>
        <ModalFooter>
          {/* <Button color="primary">
            Invite others to Sell
          </Button>
          <Button color="secondary" onClick={() => setRejectModal(!rejectModal)}>
            Reject to Sell
          </Button>
          <Button color="primary" onClick={() => setAcceptModal(!acceptModal)}>
            Accept to Sell
          </Button> */}
          <Button color="primary" onClick={() => setShowReviewVoucher(!showReviewVoucher)} style={{ background: 'gray' }}>
            Preview <i className='iconsminds-share'></i>
          </Button>
          {approvalStatus !== undefined && approvalStatus === '1' && processingFee !== undefined && <Fragment>
            <Button color="primary" onClick={() => handleUpdate('Approve')}>
              Approve
            </Button>
            <Button color="primary" onClick={() => handleUpdate('Reject')}>
              Reject
            </Button>
          </Fragment>}
          {processingFee === undefined &&
            <Fragment>
              {InviteVoucher !== undefined && <Button color="primary" onClick={ShowInviteVoucher}>
                Invite
              </Button>}
              <Button color="primary" onClick={handleSubmit}>
                Save
              </Button>

            </Fragment>}

          {thirdPartyVoucher && approvalStatus === '2' &&
            < Button
              key='Selling'
              onClick={() => {
                handleReject(voucherData.id, invitationId, 'StopSelling', voucherData.processingFee);
                toggle();
              }}
            >
              Stop Selling
            </Button>
          }
          {thirdPartyVoucher && approvalStatus === '4' &&
            <Button
              key='Reject'
              onClick={() => {
                handleReject(voucherData.id, invitationId, 'Approve', voucherData.processingFee);
                toggle();
              }}
            >
              Start Selling
            </Button>
          }

          <Button color="secondary" onClick={() => { toggle(); setShowReviewVoucherList(!showReviewVoucherList); setShowReviewVoucher(!showReviewVoucher); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
      {ImageGalleryButton()}
      {IconGalleryButton()}
      <Modal isOpen={error} toggle={() => seterror(!error)
      }>
        <ModalHeader toggle={() => seterror(!error)}>
          Voucher
        </ModalHeader>
        <ModalBody>
          <p className="m-auto">
            The Voucher has been saved as draft as some of the mandatory information is missing.
            Please complete and make the Voucher Active when ready
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => { seterror(!error); submit(voucherData); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal >
      <Modal isOpen={addTagModel} toggle={() => { setshowselect(true); setAddTagModel(!addTagModel); }}>
        <ModalHeader toggle={() => setAddTagModel(!addTagModel)}>
          ADD OWN {issearchTag === true ? "SEARCH" : "REPORTING"} TAG
        </ModalHeader>
        <ModalBody>
          <div className='margin-0'>
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => { setOwnTag(e.target.value) }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => handleOwntag(ownTag)}>
            Add
          </Button>
          <Button color="secondary" onClick={() => { setshowselect(true); setAddTagModel(!addTagModel); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={addMemberShipModal} toggle={() => { setshowselect(true); setAddMemberShipModal(!addMemberShipModal); }}>
        <ModalHeader toggle={() => setAddMemberShipModal(!addMemberShipModal)}>
          ADD OWN MEMBERSHIP
        </ModalHeader>
        <ModalBody>
          <div className='margin-0'>
            <Input
              type="text"
              name="ownTag"
              value={ownTag}
              onChange={(e) => { setOwnTag(e.target.value) }}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => AddMemberShipTags(ownTag)}>
            Add
          </Button>
          <Button color="secondary" onClick={() => { setshowselect(true); setAddMemberShipModal(!addMemberShipModal); }}>
            Close
          </Button>
        </ModalFooter>
      </Modal>

      {showReviewVoucher && <ReviewVoucher close_clicked={close_clicked} locale={locale} isCheckoutView={false} propertyData={propertyData} isVoucherEngine={true} data={voucherData}></ReviewVoucher>}

      {/* <ShowVoucherView isReview={showReviewVoucher} isVoucher={showReviewVoucherList}  
      email={email} close_clicked={()=>setShowReviewVoucherList(!showReviewVoucherList)} locale={locale} gid={getGroupID()} pid={propertyId} propertyData={propertyData} isVoucherEngine={true} 
       closeclicked={close_clicked} isCheckoutView={false} data={voucherData}
      ></ShowVoucherView> */}
    </Fragment >
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, email } = settings;
  return {
    propertyId,
    locale,
    email,
  };
};
export default injectIntl(connect(mapStateToProps)(VouchersForm));
